import { useState, useEffect } from "react";
import { useSearchParams } from "react-router";
import { PageTabs } from "@/components/ui/page-tabs";
import { ApprovalGroupsList } from "./groups";
import UsersPage from ".";
import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";

type UsersTabType = "users" | "groups";

const UsersAndGroups = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = (searchParams.get("tab") as UsersTabType) || "users";
  const [activeTab, setActiveTab] = useState<UsersTabType>(currentTab);
  const { hasPermission } = useAuthorization();
  const canReadUsers = hasPermission(Permissions.users.read);
  const canReadGroups = hasPermission(Permissions["approval-groups"].read);

  useEffect(() => {
    let urlTab = (searchParams.get("tab") as UsersTabType) || "users";
    if (urlTab === "groups" && !canReadGroups) {
      urlTab = "users";
    }
    if (urlTab === "users" && !canReadUsers) {
      urlTab = "groups";
    }
    setActiveTab(urlTab);
  }, [searchParams, canReadUsers, canReadGroups]);

  const handleTabChange = (tab: string) => {
    const newTab = tab as UsersTabType;
    setActiveTab(newTab);

    const newSearchParams = new URLSearchParams(searchParams);
    if (newTab === "users") {
      newSearchParams.delete("tab");
    } else {
      newSearchParams.set("tab", newTab);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <div>
      {/* Page Tabs */}
      <PageTabs
        tabs={[
          ...(canReadUsers ? [{ label: "Usuarios", key: "users" }] : []),
          ...(canReadGroups ? [{ label: "Grupos", key: "groups" }] : []),
        ]}
        activeKey={activeTab}
        onTabChange={handleTabChange}
        className="mb-8"
      />

      {/* Tab Content */}
      {activeTab === "users" && canReadUsers && <UsersPage />}
      {activeTab === "groups" && canReadGroups && <ApprovalGroupsList />}
    </div>
  );
};

export { UsersAndGroups };
